// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 礼品介绍列表 GET /gift/introduce/detail/list */
export async function giftIntroduceDetailListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftIntroduceDetailListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListRsGiftIntroduce>('/gift/introduce/detail/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 介绍图片 POST /gift/introduce/picture */
export async function giftIntroducePictureUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftIntroducePictureUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/gift/introduce/picture', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
